import React, { FC, useState } from 'react'

import { useRouter } from 'next/navigation'

import { StandardButton, DecorationTitle } from 'src/components/atoms'
import { DeleteUserModal, ForceUpdatePassword } from 'src/components/organisms'

import { useAuthority, useToast, useGetUsers, useGetProfile } from 'src/hooks'
import { Routes } from 'src/routes'
import { ExternalUserDetailEntity } from 'src/types'

type Props = {
  user: ExternalUserDetailEntity
  className?: string
}

export const ExternalUserManagement: FC<Props> = ({ user, className }) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false)

  const { canAssignProject } = useAuthority()
  const { displayStandardTextToast } = useToast()
  const { refetch } = useGetUsers()
  const { profile } = useGetProfile()

  const router = useRouter()

  const afterDelete = async () => {
    displayStandardTextToast('ユーザーを削除しました')
    await refetch()
    router.replace(Routes.UserList.path)
  }

  return (
    <div className={className}>
      <div className="tw-full-justify">
        <DecorationTitle>ユーザー管理</DecorationTitle>
      </div>
      {profile && (
        <>
          {/* 社外ユーザーはcompassのユーザーログインパスワードがリセット対象になるため、assignProjectポリシーで制御する */}
          {canAssignProject && <ForceUpdatePassword user={user} className="tw-mt-s1" />}
          <div className="tw-mt-s2">
            <StandardButton
              text="ユーザー削除"
              buttonType="danger"
              appendIconPath="trash/soft/line"
              onClick={() => setShowDeleteModal(true)}
              className="tw-ml-auto"
            />
          </div>
        </>
      )}

      {showDeleteModal && (
        <DeleteUserModal
          users={[user]}
          isOpen={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          afterDelete={afterDelete}
        />
      )}
    </div>
  )
}
